import React from 'react';
import { Badge, Icon } from 'antd';
import moment from 'moment';
import styles from './UserBudgetCreditsExhaustNotification.module.scss';

export default function UserBudgetCreditsExhaustNotification(props) {
  const { notification, onClick, featureToggleList } = props;
  const { UpdatedTime: updatedTime, UnreadCount: unreadCount } = notification;
  const isUserBudgetFeatureEnabled = featureToggleList.UserBudgetCapping.IsEnabled;

  return isUserBudgetFeatureEnabled ? (
    <div className={styles.notification} role="presentation" onClick={() => onClick(notification)}>
      <div className={styles.userBudgetExhaustImageWrapper}>
        <div className={styles.closeIcon}>
          <Icon type="close-circle" theme="filled" />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.bold}>User Credits Exhausted!</div>
        <span>
          Your user level credits have been exhausted. Please contact your admin to add more credits to your account.
        </span>
        <div className={styles.time}>{moment.utc(updatedTime).local().fromNow()}</div>
      </div>
      <div className={styles.viewSymbol}>
        <Badge dot={unreadCount > 0} />
      </div>
    </div>
  ) : null;
}
